__turbopack_context__.v({
  "myTasks": "MyTasks-module__hm0coW__myTasks",
  "myTasksHeader": "MyTasks-module__hm0coW__myTasksHeader",
  "taskCount": "MyTasks-module__hm0coW__taskCount",
  "taskItem": "MyTasks-module__hm0coW__taskItem",
  "tasksContainer": "MyTasks-module__hm0coW__tasksContainer",
});
